import React from "react";
import "./PaymentOptions.css";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Box,
  TextField,
  Typography,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Copyright2 from "components/footerpt2/Copyright2";
import pic from "components/assets/logo-tran.png";

const PaymentOptions: React.FC = () => {
  const openLink = (url: string) => {
    window.open(url, "_blank");
  };

  return (
    <div className="parent-div">
      <div className="payment-container">
        <h2>Select a Payment Method</h2>
        <div className="payment-buttons-container">
          <Tooltip title="You can establish automated ACH payments at no cost by completing our ACH form. Please note  that you will receive your invoices electronically prior to our monthly ACH draft.">
            <button
              className="payment-button"
              onClick={() => openLink("https://www.optimedhealthportal.com/forms/achAgreement")}
            >
              ACH
            </button>
          </Tooltip>
          <Tooltip title="Please note that if you need to mail a payment to us you can sent Premium payments to 'OptiMedHealth, 3700 Mansell Road Suite 250 Alpharetta, GA 30022-1520'">
            <button className="payment-button">Mail</button>
          </Tooltip>
        </div>
        <br />
        <Typography variant="body2" color="textSecondary">
          OptiMedHealth offers 2 payment options for groups to pay for their Health Plan Premiums. Hover over each
          option and they click on the requested option to complete the necessary information to process your
          payment(s).
        </Typography>
        {/* <div className="copyright">{<Copyright2 />}</div> */}
      </div>
      {/* Moved the Copyright component to the bottom */}
      <div className="copyright-fixed">
        <Copyright2 />
      </div>
    </div>
  );
};

export default PaymentOptions;
// ... Existing code
export {};
